<!-- prettier-ignore -->

<div class="add-item-header">
    <span>{{'Añadir Item' | translate }} {{'Día' | translate}} {{day + 1}} {{'a las' | translate}} {{hour}}</span>
    <ion-icon (click)="closeModal()" style="padding: 10px; font-size: 30px; color: #fff; cursor: pointer" name="close"></ion-icon>
</div>

<div class="search-container">
    <div style="display: flex; width: 100%; gap: 15px; min-width: 60%;">
        <select [(ngModel)]="selectedCategory" (change)="handleSelectChange()">
            <option [value]="null"> {{ 'Todas las categorías' | translate }}  </option>
            @if (availableTechItems?.length > 0){
                <option [value]="'tech'"> {{ 'Seleccionados por técnico' | translate }}  </option>
            }
            @for (category of categories; track category;) {
                <option [value]="category?.id"> {{ category?.name?.[translate.currentLang] }}  </option>
            }
        </select>
        @if(apps?.length > 0){
            <select [(ngModel)]="selectedApp" (change)="handleSelectChange()">
                <option [value]="null"> {{ 'Todas los municipios' | translate }}  </option>
                @for (app of apps; track app;) {
                    <option [value]="app?.id"> {{ app?.name?.[translate.currentLang] }}  </option>
                }
            </select>
        }
    </div>

    <input autocomplete="off" [(ngModel)]="searchInputValue" (ngModelChange)="onInputChange($event)" [placeholder]="'Buscador' | translate">
</div>

<div class="items-container" [ngClass]="{'custom-style': checkCustomStyle()}">
    @if(searchItems?.length > 0){
        @for (item of searchItems; track $index;) {
            <div (click)="showItemInfo(item)" class="add-item-card">
                <div class="wrapper">
                    <div class="distance">
                        {{item?.distanceM}}
                    </div> 
                    <div class="duration">
                        {{item?.durationc}}
                    </div> 
                    <div class="card-image-wrapper">
                        <!-- <img [src]="item?.cover_image"> -->
                        <cicerone-lazy-image class="cicerone-lazy-image" [url]="item.image" [urlFallback]="item.imageFallback" [altImage]="item?.name?.[translate.currentLang]"></cicerone-lazy-image>
                    </div>
                    <div class="card-text-wrapper">
                        <span class="card-text">
                            {{item?.name?.[translate.currentLang]}}
                        </span>
                        <ion-icon (click)="addItem($event, item)" class="plus-add-item" name="add-outline" ></ion-icon>
                    </div>
                </div>
            </div>
        }
    }
    @else{
        <span style="font-size: 18px;">{{ 'No se han encontrado resultados...' | translate }}</span>
    }

</div>